import React from "react";
import { useCart } from "../../hooks/CartContext";
import { ProductSkeleton } from "../../components/common/ProductSkeleton";
import { useQuery } from "@tanstack/react-query";
import { FaShoppingCart, FaStar } from "react-icons/fa";
import { IoIosArrowRoundForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const PlayStation5 = () => {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const link = "PlayStation";
  const { data: products, isLoading } = useQuery({
    queryKey: ["brand", link],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/products/product/brands/brand?brand=${encodeURIComponent(link)}`,
      );
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Something went wrong");
      }
      ;
      return data;
    },
  });

  return (
    <div className="bg-black p-2 md:py-12 py-8 px-8 w-full">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-white font-bold text-3xl">
          Play<span className="text-orange-600">Station</span>
        </h2>

       <Link
  to="/filter"
  className="text-white flex items-center gap-2 transition px-6 py-2 border border-gray-600 rounded-md hover:opacity-90"
>
  See All <IoIosArrowRoundForward size={20} />
</Link>

      </div>

      {/* Slider */}
      <Swiper
        modules={[Navigation, Autoplay]}
        loop
        navigation
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        breakpoints={{
          0: { slidesPerView: 1.2, spaceBetween: 12 },
          480: { slidesPerView: 2, spaceBetween: 15 },
          640: { slidesPerView: 2.5, spaceBetween: 15 },
          1024: { slidesPerView: 4, spaceBetween: 20 },
          1280: { slidesPerView: 5, spaceBetween: 25 },
        }}
        className="rounded-md"
        style={{ "--swiper-navigation-color": "#fff" }}
      >
        {/* Loading */}
        {isLoading
          ? Array.from({ length: 8 }).map((_, i) => (
              <SwiperSlide key={i}>
                <ProductSkeleton />
              </SwiperSlide>
            ))
          : products?.products?.slice(0, 10).map((product) => (
              <SwiperSlide key={product._id}>
                <div
                  onClick={() => navigate(`/product/${product._id}`)}
                  className="bg-white rounded-xl shadow hover:shadow-lg cursor-pointer transition overflow-hidden"
                >
                  <img
                    src={product?.images?.[0]}
                    alt={product?.name}
                    className="h-48 w-full object-cover"
                  />

                  <div className="p-4">
                    <div className="flex justify-between">
                      <h3 className="font-semibold text-gray-700 truncate">
                        {product?.name}
                      </h3>
                      <span className="text-gray-500 text-sm">
                        {product?.category}
                      </span>
                    </div>

                    <div className="flex justify-between mt-2 text-sm">
                      <span className="flex items-center gap-1 text-yellow-500 font-bold">
                        <FaStar />
                        {product?.averageRating?.toFixed(1) || "0.0"}
                      </span>
                      <span className="text-rose-700 font-medium">
                        {product?.quantity} left
                      </span>
                    </div>

                    <div className="flex justify-between mt-2">
                      <span className="font-bold text-gray-600">
                        ₦{product?.finalPrice?.toLocaleString()}
                      </span>
                      {
                        product?.discount > 0 &&  <span className="line-through text-red">
                        ₦{product?.price?.toLocaleString()}
                      </span>
                      }
                     
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        addToCart(product);
                      }}
                      disabled={product?.quantity < 1}
                      className="mt-4 w-full bg-red text-white py-2 rounded-md flex items-center justify-center gap-2 hover:bg-red hover:bg-opacity-75 transition-all"
                    >
                      <FaShoppingCart />{" "}
                      {product?.quantity < 1 ? "Sold Out" : "Add to Cart"}
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
      </Swiper>
    </div>
  );
};

export default PlayStation5;
